import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Loading } from "../../components/Loading";
import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useUsuarios, UsuarioFilter } from "../../hooks/usuarios/useUsuarios";
import { Item } from "./Item";

export function Lista() {
  const { watch } = useFormContext();

  const [filter, setFilter] = useState<UsuarioFilter | undefined>(undefined);

  const filtrar = watch("filter");

  const { data, isLoading } = useUsuarios({ filter });

  useEffect(() => {
    if (filtrar !== undefined) {
      setFilter(filtrar);
    }
  }, [filtrar]);

  if (isLoading) return <Loading />;

  return (
    <>
        <Box
          width={"full"}
          fontSize={"sm"}
          p={"5"}
          border={"1px solid #ccc"}
          display={"flex"}
          flexDir={"column"}
        >
          <Box
            mt={"-8"}
            fontWeight={"bold"}
            bg={"white"}
            as={"span"}
            w={"200px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            Resultado da Pesquisa
          </Box>
        <TableContainer>
          <Table variant={"striped"}>
            <Thead>
              <Tr color={'white'}>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>#</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>Nome</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>Perfil</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>Status</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>Empresa</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>E-mail</Th>
                <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.usuarios.map(item => <Item key={item.id} usuario={item} />)}
            </Tbody>
          </Table>
        </TableContainer>
        </Box>
    </>
  );
}
